import { Link } from "react-router-dom";

import { BreadCrumbItemProps } from "./types";

const checkIsLink = (paths: string[], currentPath?: string) => {
	if (!paths.length || !currentPath) return false;

	return currentPath !== paths[paths.length - 1];
};

export const BreadCrumbItem = ({ route, paths }: BreadCrumbItemProps) => {
	const isLink = checkIsLink(paths, route.path);

	return isLink ? <Link to={route.path || ""}>{route.title}</Link> : <span>{route.title}</span>;
};
